<template>
  <div class="page" ref="page">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>1</van-swipe-item>
      <van-swipe-item>2</van-swipe-item>
      <van-swipe-item>3</van-swipe-item>
      <van-swipe-item>4</van-swipe-item>
    </van-swipe>
    <div class="title">
      常用操作
    </div>
    <van-grid :column-num="3">
      <van-grid-item to="/orderList" icon="photo-o" text="订单" />
      <van-grid-item icon="photo-o" text="返瓶" />
      <van-grid-item icon="photo-o" text="结算" />
      <van-grid-item to="/managementHome" icon="photo-o" text="管理首页" />
      <van-grid-item to="/cylinderManageUserHome" icon="photo-o" text="钢瓶管理人员首页" />
      <van-grid-item to="/fillingUserHome" icon="photo-o" text="充装人员首页" />
      <van-grid-item to="/warehouseUserHome" icon="photo-o" text="库管人员首页" />
    </van-grid>
    <div class="title title-news van-hairline--bottom">
      新闻列表
    </div>
    <ul class="news-list">
      <news-list-item v-for="item in 8" :key="item" />
    </ul>
    <!-- 加载更多 -->
    <div v-if="showLoadingMore" class="loading-more">
      <van-loading size="24px">正在载中...</van-loading>
    </div>
  </div>
</template>

<script>
import NewsListItem from './components/NewsListItem.vue'
import { onMounted, ref } from 'vue'
// import { getUrlParam } from '@/utils/common'
// import axios from 'axios'
export default {
  name: 'Home',
  components: { NewsListItem },
  setup () {
    const page = ref(null)
    const showLoadingMore = ref(false)

    onMounted(() => {
      page.value.addEventListener('scroll', ({ target }) => {
        const { scrollTop, scrollHeight, clientHeight } = target
        const maxH = scrollHeight - clientHeight
        if (scrollTop >= maxH) {
          showLoadingMore.value = true
        }
      })
      // test
      // const code = getUrlParam('code')
      // axios.get(`http://192.168.1.18:8765/api/goods/user/wechat/getUserOpenId?code=${code}`)
      //   .then(res => {
      //     console.log(res)
      //   }).catch(err => {
      //     console.log(err)
      //   })
    })
    return { page, showLoadingMore }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100vh;
  background-color: #ededed;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    line-height: 45px;
    text-indent: 16px;
    background-color: #fff;
    margin-top: 16px;
  }
  .title-news {
    position: sticky;
    top: 0;
    z-index: 2;
  }
  .news-list {
    background-color:#ffffff;
  }
  .loading-more {
    text-align: center;
    margin: 16px;
  }
}

</style>
